import PhototherapyConfigPage from '../phototherapy/PhototherapyConfigPage';
import { BILI2022_VARIANT } from '../../../apps/phototherapy/variants';

/**
 * Admin console for the "צהבת ביילוד AAP 2022" app (`BILI2022`).
 * Shares the whole UI with the צהבת ביילוד console — only the AppConfig identity
 * and the default calculator (AAP 2022 here) differ.
 */
const Bili2022Config = () => <PhototherapyConfigPage variant={BILI2022_VARIANT} />;

export default Bili2022Config;
